/* eslint-disable react/no-unescaped-entities */
import React from "react"
import { Route, Redirect } from "react-router"

const ProtectedRoute = ({ component: Component, isPermitted, ...props }) => {
  return (
    <Route
      {...props}
      render={(prop) =>
        isPermitted ? (
          <Component {...prop} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: {
                from: props.location,
              },
            }}
          />
        )
      }
    />
  )
}

export default ProtectedRoute
